import { graphql, readInlineData } from 'react-relay';

import { trackEcommerce, eventNameConstants, trackingConstants } from 'dibs-tracking';

import { getPromoCreative } from '../../helpers/getPromoCreative.js';

import {
    type promoTracking_messages$key,
    type promoTracking_messages$data,
} from './__generated__/promoTracking_messages.graphql.ts';
import { type promoTracking_promotion$key } from './__generated__/promoTracking_promotion.graphql.ts';

const messagesFragment = graphql`
    fragment promoTracking_messages on PromoModuleMessages @inline {
        items {
            linkData {
                path
            }
        }
    }
`;

const promotionFragment = graphql`
    fragment promoTracking_promotion on PromoItem @inline {
        linkData {
            path
        }
    }
`;

const buildItemTrackingObject = ({
    item,
    index,
}: {
    item: NonNullable<promoTracking_messages$data['items']>[0] | null;
    index: number;
}): { id: string; name: string; creative: string; position: number } => {
    const url = item?.linkData?.path || '';
    const position = index + 1;

    return {
        id: `promo-banner-${position}`,
        name: `Promo Banner #${position}`,
        creative: getPromoCreative(url),
        position,
    };
};

export const trackPromoImpressions = ({
    messages: messagesRef,
    startingIndex,
}: {
    messages: promoTracking_messages$key | null;
    startingIndex: number;
}): void => {
    const messages = readInlineData(messagesFragment, messagesRef);

    trackEcommerce({
        type: trackingConstants.ECOM_PRODUCT_PROMO_IMPRESSION,
        eventName: eventNameConstants.EVENT_VIEW_PROMOTION,
        promotions: messages?.items?.map((item, index) =>
            buildItemTrackingObject({ item, index: index + startingIndex })
        ),
    });
};

export const trackPromoClick = ({
    promotion: promotionRef,
    index,
}: {
    promotion: promoTracking_promotion$key;
    index: number;
}): void => {
    const promotion = readInlineData(promotionFragment, promotionRef);

    trackEcommerce({
        type: trackingConstants.ECOM_PRODUCT_PROMO_CLICK,
        eventName: eventNameConstants.EVENT_SELECT_PROMOTION,
        promotions: [buildItemTrackingObject({ item: promotion, index })],
    });
};
